import React, { useState } from 'react';
import {
  Container, Box, Paper, Typography, TextField,
  Button, IconButton, InputAdornment, Fade
} from '@mui/material';
import { Visibility, VisibilityOff, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import '../styles/styles.css';

const Register = ({ notificationsRef }) => {
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) { notificationsRef.current.showSnackbar('Name is required.', 'error'); return; }
    if (!username) { notificationsRef.current.showSnackbar('Username is required.', 'error'); return; }
    if (!email) { notificationsRef.current.showSnackbar('Email is required.', 'error'); return; }
    if (!password) { notificationsRef.current.showSnackbar('Password is required.', 'error'); return; }
    if (!confirmPassword) { notificationsRef.current.showSnackbar('Please confirm your password.', 'error'); return; }
    if (password !== confirmPassword) { notificationsRef.current.showSnackbar("Passwords don't match.", 'error'); return; }
    if (!/^[a-z0-9]+$/.test(username)) { notificationsRef.current.showSnackbar('Username: lowercase and numbers only.', 'error'); return; }

    setLoading(true);
    try {
      await api.register({ name, username, email, password });
      notificationsRef.current.showSnackbar('Account created. Welcome!', 'success');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      notificationsRef.current.showSnackbar(err.message, 'error');
      setLoading(false);
    }
  };

  return (
    <Box className="registerContainer">
      <IconButton onClick={() => navigate(-1)} className="registerBackButton" color="primary">
        <ArrowBack />
      </IconButton>
      <Container component="main" maxWidth="xs" className="registerMainContainer">
        <Fade in={true} timeout={600}>
          <Paper elevation={0} className="registerPaper">
            <Box className="safeHeader" style={{ marginBottom: 24 }}>
              <Typography component="h1" className="registerTitle">Create account</Typography>
            </Box>
            <form onSubmit={handleSubmit} noValidate style={{ width: '100%' }}>
              <TextField required fullWidth margin="dense" label="Full Name" autoFocus value={name} onChange={(e) => setName(e.target.value)} />
              <TextField required fullWidth margin="dense" label="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
              <TextField required fullWidth margin="dense" label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <TextField
                required fullWidth margin="dense" label="Password"
                type={showPassword ? 'text' : 'password'} value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowPassword(p => !p)} edge="end">{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>) }}
              />
              <TextField
                required fullWidth margin="dense" label="Confirm Password"
                type={showPassword ? 'text' : 'password'} value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowPassword(p => !p)} edge="end">{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>) }}
              />
              <Button type="submit" fullWidth variant="contained" className="registerSubmitButton" disabled={loading}>
                {loading ? 'Creating account...' : 'Create Account'}
              </Button>
            </form>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default Register;